export default "__VITE_ASSET__D1dpPL_N__"